// Additional polyfills
import 'custom-event-polyfill'
import 'url-polyfill'

import Vue from 'vue'
import App from './App'
import router from './router'

import BootstrapVue from 'bootstrap-vue'
import layer from 'vue-layer'
import 'vue-layer/lib/vue-layer.css'

import globals from './globals'
import Popper from 'popper.js'

import store from './store/index'
import components from './store/components'

import showmsg from './store/msg'
import enu from './store/enu'

import Vuex from 'vuex'
import QS from 'qs'
import axios from './api/http'

// table
import 'xe-utils'
import VXETable from 'vxe-table'
import 'vxe-table/lib/style.css'

// 弹框组件
import Swal from 'sweetalert2/dist/sweetalert2.js'
import 'sweetalert2/src/sweetalert2.scss'
// 日期组件
import DatePicker from 'vue2-datepicker'
// import 'vue2-datepicker/index.css'
import 'vue2-datepicker/locale/zh-cn'
// tab组件
import RouterTab from 'vue-router-tab'
import './css/vue-router-tab.css'
import './css/index.css'
// iconfont
import './css/iconfont/iconfont.css'
import './css/iconfont/iconfont.js'
// tree
import vuetree from 'vue2-org-tree'
// treeselect
import treeselect from '@riophae/vue-treeselect'

// 打印组件
import Print from 'vue-print-nb'

import { dateShortcuts, timeShortcuts } from './datepicker/shortcuts'
// 日期
import moment from 'moment'// 导入文件
Vue.prototype.$moment = moment// 赋值使用
Vue.prototype.$dateShortcuts = dateShortcuts// 赋值使用
Vue.prototype.$timeShortcuts = timeShortcuts// 赋值使用
// Required to enable animations on dropdowns/tooltips/popovers
Popper.Defaults.modifiers.computeStyle.gpuAcceleration = false

Vue.config.productionTip = false
Vue.use(BootstrapVue)
Vue.use(DatePicker)
Vue.use(RouterTab)
Vue.use(vuetree)
Vue.use(treeselect)
Vue.use(Print)

Vue.use(VXETable)
Vue.prototype.$XModal = VXETable.modal

Vue.prototype.$layer = layer(Vue)

Vue.prototype.$axios = axios

Vue.prototype.$Swal = Swal
Vue.prototype.qs = QS
Vue.use(Vuex)
// Global RTL flag
Vue.mixin({
  data: globals
})

new Vue({
  router,
  store,
  showmsg,
  enu,
  components,
  render: h => h(App)
}).$mount('#app')
